export default __webpack_public_path__ + "static/media/emptyBetslip.7105ce2a.svg";